import React from 'react';
import { useStore } from 'effector-react';
import { HSIconType } from '@types';
import { Collapse } from '@components/Collapse';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { $loadedScene } from '@stores/loadedStore';
import { hotspotIconDefault, reAddEditingHotspot } from '../../../hotspot';
import IconSettingSystem from './IconSettingSystem';
import IconSettingMark from './IconSettingMark';
import IconSettingImage from './IconSettingImage';
import IconSettingSeqFrame from './IconSettingSeqFrame';
import IconSettingVideo from './IconSettingVideo';
import IconSettingPolygon from './IconSettingPolygon';

const items: DropdownItem<HSIconType>[] = [
  { id: HSIconType.system, name: '系统图标' },
  { id: HSIconType.mark, name: '文字标记' },
  { id: HSIconType.image, name: '图片' },
  { id: HSIconType.seqFrame, name: '序列帧' },
  { id: HSIconType.video, name: '视频' },
  { id: HSIconType.polygon, name: '多边形' },
];

function IconSetting() {
  const sceneType = useStore($loadedScene.map((s) => s?.type));
  const { hotspot } = useStore($editingHotspot)!;
  const { icon } = hotspot;

  const handleIconTypeChange = (typeId: HSIconType) => {
    const newIcon = hotspotIconDefault({
      type: typeId,
      ath: hotspot.icon.ath,
      atv: hotspot.icon.atv,
      featType: hotspot.data.code,
    });
    $editingHotspotApi.update((draft) => {
      draft.icon = newIcon;
      if (typeId === HSIconType.mark) {
        draft.showTitle = 1;
      }
    });
    reAddEditingHotspot();
  };

  return (
    <Collapse title="图标设置">
      <Dropdown
        items={items}
        className="mb-20"
        selected={hotspot.icon.type}
        onChange={handleIconTypeChange}
      />
      {icon.type === HSIconType.system && <IconSettingSystem />}
      {icon.type === HSIconType.mark && <IconSettingMark />}
      {icon.type === HSIconType.image && <IconSettingImage />}
      {icon.type === HSIconType.seqFrame && <IconSettingSeqFrame />}
      {icon.type === HSIconType.video && <IconSettingVideo />}
      {icon.type === HSIconType.polygon && <IconSettingPolygon />}
    </Collapse>
  );
}

export default IconSetting;
